/* NOT SO BASIC collection page: "Shop the collection" bar on phones. Add to bag is handled by lfr-restock.js. */
(function () {
  if (window.nsbCollection) return;
  window.nsbCollection = true;

  function bindSticky() {
    var sticky = document.querySelector('[data-nsb-sticky]');
    var products = document.querySelector('[data-nsb-products]');
    if (!sticky || !products || sticky.dataset.nsbBound) return;
    sticky.dataset.nsbBound = '1';
    var link = sticky.querySelector('a');
    // Shown once the visitor has scrolled past the products; hidden while the products, the About
    // section or the footer are on screen, wherever those sections are placed. Checked on scroll so
    // jumps (anchor links, fast flicks) can't leave it in the wrong state.
    var ticking = false;
    function onScreen(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
    function update() {
      ticking = false;
      if (!document.body.contains(products)) return;
      var past = products.getBoundingClientRect().bottom < 0;
      var covered = onScreen(products) || onScreen(document.querySelector('[data-lfr-about]')) || onScreen(document.querySelector('footer'));
      var show = past && !covered;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.tabIndex = show ? 0 : -1;
    }
    function request() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindSticky);
  else bindSticky();
  document.addEventListener('shopify:section:load', bindSticky);
})();